import Pill from "../../General/Pill";

const AgentLicenseCard = ({
  isLicenseExpired,
  licenseNumber,
  licenseState,
  terminationDate,
  statusObject,
}) => {
  const { status, statusText } = statusObject;

  return (
    <article className="ui-card p-2 grid grid-cols-2 gap-4 xl:p-6">
      <div>
        <h3 className="font-semibold">{licenseState}</h3>
        {licenseNumber ? <p className="text-xs">{licenseNumber}</p> : null}
        <div className="pt-2">
          <Pill status={status} statusText={statusText} />
        </div>
      </div>
      <div>
        <h3 className="text-xs">{isLicenseExpired ? "Expired" : "Expires"}</h3>
        <h3 className="text-sm font-semibold">{terminationDate}</h3>
      </div>
    </article>
  );
};

export { AgentLicenseCard };
